import { fileService } from 'services';
import shortid from 'shortid';


const UPLOAD_SUCCESS = 'files/UPLOAD_SUCCESS';
const UPLOAD_FAILED = 'files/UPLOAD_FAILED';
const FETCH_BEGIN = 'files/FETCH_BEGIN';
const FETCH_SUCCESS = 'files/FETCH_SUCCESS';
const FETCH_ERROR =  'files/FETCH_ERROR';

export function uploadFileSuccess(){
    return {
        type: UPLOAD_SUCCESS
    }
}

export function uplodFileError(error){
    return {
        type: UPLOAD_FAILED,
        msg: error
    }
}

export function removeFile(id, websiteId){
    return (dispatch) => {
        fileService().deleteFile(id).then(()=>{
            dispatch(fetchFiles(websiteId));
        });
    }
}

export function uploadFile(file, websiteId){
    return (dispatch) => {
        let data = new FormData();
        let fileId= shortid.generate() + '-' + file.name;
        data.append('file', file);
        data.append('name', fileId);
        fileService().uploadFile({
            id: fileId,
            data: data
        }, websiteId).then((res)=>{
            if (res.data.indexOf('Performing Maintenance') !== -1){
                dispatch(uplodFileError('Failed to upload file'));
            }else{
                dispatch(uploadFileSuccess());
                dispatch(fetchFiles(websiteId));
            }
        }).catch(()=>{
            dispatch(uplodFileError('Failed to upload file'));
        });
    }
}

export function fetchFilesBegin(){
    return {
        type: FETCH_BEGIN
    }
}

export function fetchFilesSuccess(data){
 return { type: FETCH_SUCCESS, data: data };
}

export function fetchFilesError(error){
 return { type: FETCH_ERROR, error: error };
}

export function fetchFiles(websiteId){
    return (dispatch) => {
        dispatch(fetchFilesBegin());
        fileService().getFiles(websiteId).then((res)=>{
           return dispatch(fetchFilesSuccess(res.data));
        }).catch((error)=> {
            return dispatch(fetchFilesError('Cannot fetch websites. Please try later.'));
        });
    }
}


const reducer = (state = {
    fetching: false,
    isSaving: false,
    uploadFailed: false,
    list: []
}, action = {}) => {
  
  switch (action.type) {
    case FETCH_BEGIN:
        return {
            ...state,
            fetching: true,
            isSaving: false,
            list:[],
            uploadFailed: false
        };
    case FETCH_SUCCESS:

        return {
            ...state,
            fetching: false,
            list: [...action.data],
            uploadFailed: false
        };
    case FETCH_ERROR:
        return {
            ...state,
            fetching: false,
            isSaving: false,
            list: []
        };
    case UPLOAD_SUCCESS:
        return {
            ...state,
            uploadFailed: false
        }
    case UPLOAD_FAILED:
        return {
            ...state,
            uploadFailed: true
        }
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// app/modules/files.js